<ng-container [formGroup]="formGroup">
  <table class="table-striped table-no-border-bottom">
    <tr>
      <td>
        <h2 class="heading-underline">Select default output format</h2>
        <mat-button-toggle-group
          id="word-pdf-both"
          class="small-icons-only"
          formControlName="outputFormat"
          [hideSingleSelectionIndicator]="true"
        >
          <mat-button-toggle
            class="word-toggle"
            [value]="'docx'"
            [matTooltip]="'Select default output format as a Word Document (.docx)'"
            matTooltipShowDelay="500"
          >
            <app-filetype-icon [value]="'docx'"></app-filetype-icon>
            Word
          </mat-button-toggle>
          <mat-button-toggle
            class="pdf-toggle"
            [value]="'pdf'"
            [matTooltip]="'Select default output format as a PDF'"
            matTooltipShowDelay="500"
          >
            <app-filetype-icon [value]="'pdf'"></app-filetype-icon>
            PDF
          </mat-button-toggle>
          <mat-button-toggle
            class="both-toggle"
            [value]="'docx,pdf'"
            [matTooltip]="'Select default output format as both a Word Document (.docx) and PDF'"
            matTooltipShowDelay="500"
          >
            <app-filetype-icon [value]="'docx'"></app-filetype-icon>
            <app-filetype-icon [value]="'pdf'"></app-filetype-icon>
            Both
          </mat-button-toggle>
        </mat-button-toggle-group>
      </td>
    </tr>
  </table>
</ng-container>
